import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import { useSettings } from "@/lib/useSettings";

export default function ProjectsStrip({ projects = [] }) {
  const { settings } = useSettings();
  return (
    <section className="py-20 md:py-28 bg-slate-50" data-testid="projects-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="aman-tag-dark">أعمالنا</span>
              <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] leading-tight">
                {settings?.projects_section_title_ar || "مشاريع أنجزناها بفخر في مختلف المحافظات"}
              </h2>
              <p className="mt-4 text-slate-600 leading-relaxed">
                {settings?.projects_section_desc_ar || "نماذج من مشاريعنا الأخيرة — من المجمعات التجارية إلى المستشفيات والفيلات السكنية."}
              </p>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-testid="projects-grid">
          {projects.map((p, i) => (
            <Reveal key={p.id || p.title_ar} delay={i * 60}>
              <article className="group relative overflow-hidden rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-xl transition-shadow">
                <div className="relative aspect-[16/11] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title_ar}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/85 via-[#0A1628]/20 to-transparent" />
                  <div className="absolute top-4 start-4 flex items-center gap-2">
                    <span className="aman-tag !bg-[#0A1628]/70 !border-white/20 !text-white !text-[11px]">
                      <Icon name="map-pin" size={12} />
                      {p.location_ar}
                    </span>
                    {p.date_ar && (
                      <span className="text-xs font-medium text-white/80">{p.date_ar}</span>
                    )}
                  </div>
                  <div className="absolute bottom-4 start-4 end-4">
                    <h3 className="font-heading text-white text-lg font-bold leading-tight">
                      {p.title_ar}
                    </h3>
                  </div>
                </div>
                <div className="p-5">
                  <p className="text-slate-600 text-sm leading-relaxed">{p.description_ar}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
